import { z } from 'zod';
import { hostedSessionDTOSchema, partnerActivityDTOSchema, partnerBillingSummaryDTOSchema, partnerCommissionLineDTOSchema, partnerCommissionPeriodDTOSchema, partnerCustomerCreatedDTOSchema, partnerEarningsSummaryDTOSchema, partnerInvoiceDTOSchema, partnerMemberDTOSchema, partnerPortalCustomerDTOSchema, partnerSetupHandoffDTOSchema, } from '@instanexus/contracts';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX, } from '../transport.js';
const listCustomersSchema = listEnvelopeSchema(partnerPortalCustomerDTOSchema);
const openSetupSchema = dataEnvelopeSchema(partnerSetupHandoffDTOSchema);
const createCustomerSchema = dataEnvelopeSchema(partnerCustomerCreatedDTOSchema);
const listTeamSchema = listEnvelopeSchema(partnerMemberDTOSchema);
const teamMemberSchema = dataEnvelopeSchema(partnerMemberDTOSchema);
const listActivitySchema = listEnvelopeSchema(partnerActivityDTOSchema);
const billingSummarySchema = dataEnvelopeSchema(partnerBillingSummaryDTOSchema);
const listInvoicesSchema = listEnvelopeSchema(partnerInvoiceDTOSchema);
const billingPortalSchema = dataEnvelopeSchema(hostedSessionDTOSchema);
const earningsSummarySchema = dataEnvelopeSchema(partnerEarningsSummaryDTOSchema);
const listEarningPeriodsSchema = listEnvelopeSchema(partnerCommissionPeriodDTOSchema);
const listEarningLinesSchema = listEnvelopeSchema(partnerCommissionLineDTOSchema);
export function createPartnerPortalResource(transport) {
    return {
        async listCustomers(params = {}) {
            return transport.request({
                path: `${WEB_API_PREFIX}/partner/customers`,
                schema: listCustomersSchema,
                query: { page: params.page, pageSize: params.pageSize },
            });
        },
        async openSetup(tenantId, input) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/partner/customers/${encodeURIComponent(tenantId)}/setup-sessions`,
                schema: openSetupSchema,
                method: 'POST',
                body: { destination: input?.destination ?? 'console' },
            });
            return envelope.data;
        },
        async createCustomer(input) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/partner/customers`,
                schema: createCustomerSchema,
                method: 'POST',
                body: input,
            });
            return envelope.data;
        },
        async sendOwnerInvite(tenantId, input) {
            await transport.request({
                path: `${WEB_API_PREFIX}/partner/customers/${encodeURIComponent(tenantId)}/owner-invite`,
                schema: z.undefined(),
                method: 'POST',
                body: input,
            });
        },
        async listTeam(params = {}) {
            return transport.request({
                path: `${WEB_API_PREFIX}/partner/team`,
                schema: listTeamSchema,
                query: { page: params.page, pageSize: params.pageSize },
            });
        },
        async inviteTeamMember(input) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/partner/team`,
                schema: teamMemberSchema,
                method: 'POST',
                body: input,
            });
            return envelope.data;
        },
        async changeTeamMemberRole(membershipId, input) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/partner/team/${encodeURIComponent(membershipId)}`,
                schema: teamMemberSchema,
                method: 'PATCH',
                body: input,
            });
            return envelope.data;
        },
        async removeTeamMember(membershipId) {
            await transport.request({
                path: `${WEB_API_PREFIX}/partner/team/${encodeURIComponent(membershipId)}`,
                schema: z.undefined(),
                method: 'DELETE',
            });
        },
        async listActivity(params = {}) {
            return transport.request({
                path: `${WEB_API_PREFIX}/partner/activity`,
                schema: listActivitySchema,
                query: { page: params.page, pageSize: params.pageSize },
            });
        },
        async getBilling() {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/partner/billing`,
                schema: billingSummarySchema,
            });
            return envelope.data;
        },
        async listInvoices(params = {}) {
            return transport.request({
                path: `${WEB_API_PREFIX}/partner/billing/invoices`,
                schema: listInvoicesSchema,
                query: { page: params.page, pageSize: params.pageSize },
            });
        },
        async openBillingPortal() {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/partner/billing/portal-session`,
                schema: billingPortalSchema,
                method: 'POST',
            });
            return envelope.data;
        },
        async getEarnings() {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/partner/earnings`,
                schema: earningsSummarySchema,
            });
            return envelope.data;
        },
        async listEarningPeriods(params = {}) {
            return transport.request({
                path: `${WEB_API_PREFIX}/partner/earnings/periods`,
                schema: listEarningPeriodsSchema,
                query: { page: params.page, pageSize: params.pageSize },
            });
        },
        async listEarningLines(params) {
            return transport.request({
                path: `${WEB_API_PREFIX}/partner/earnings/lines`,
                schema: listEarningLinesSchema,
                query: {
                    period: params.period,
                    currency: params.currency,
                    page: params.page,
                    pageSize: params.pageSize,
                },
            });
        },
    };
}
//# sourceMappingURL=partner-portal.js.map